import React from 'react';

export function HandDrawnQuote({ className = '' }: Readonly<{ className?: string }>): React.ReactElement {
  return (
    <svg
      className={className}
      width="80"
      height="70"
      viewBox="0 0 80 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10,35 Q10,12 25,12 Q40,12 40,35 Q40,58 25,58 Q10,58 10,35"
        stroke="currentColor"
        strokeWidth="3"
        strokeOpacity="0.25"
        fill="none"
      />
      <path
        d="M45,35 Q45,12 60,12 Q75,12 75,35 Q75,58 60,58 Q45,58 45,35"
        stroke="currentColor"
        strokeWidth="3"
        strokeOpacity="0.25"
        fill="none"
      />
    </svg>
  );
}
